<template>
  <footer class="footer">
    <VerInfo />
  </footer>
</template>

<script>
import VerInfo from "./VerInfo"
export default {
  name: "Footer",
  components: {
    VerInfo
  },
  data() {
    return {}
  }
}
</script>

<style scoped>
.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--blue-dark);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/layout/desktop/Footer.vue